module.exports = __webpack_public_path__ + "static/media/ab-educations.8b2840c8.webp";